var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolCalibrate = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25
}, /*#__PURE__*/React.createElement("path", {
  d: "m22.5 22.5 3-3-3-3M3.5 19.5h21M5.5 22.5l-3-3 3-3"
})), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 6,
  x: 2,
  y: 5,
  stroke: "currentColor",
  strokeWidth: 1.25,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M6.5 10.5v-2M9.5 10.5v-2M12.5 10.5v-2M15.5 10.5v-2M18.5 10.5v-2M21.5 10.5v-2"
}))));
export { SvgToolCalibrate as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-calibrate.svg";